module.exports = __webpack_public_path__ + "img/sample_cmc.b3cf9900.png";